import { Component } from '@angular/core';
import { CellComponent } from '@spartacus/organization/administration/components';
import { OutletContextData, TableDataOutletContext } from '@spartacus/storefront';

@Component({
    selector: 'app-uig-cell',
    templateUrl: './uig-cell.component.html',
    styleUrls: ['./uig-cell.component.scss'],
    standalone: false
})
export class UigCellComponent extends CellComponent {

  constructor(protected outlet: OutletContextData<TableDataOutletContext>) {
    super(outlet);
  }

  get routeForLocalization(): string {
    return this.outlet.context._i18nRoot + 'Details';
  }

}
